import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function ImpactoHero() {
  const { t } = useTranslation();
  return (
    <section
      className="relative isolate overflow-hidden bg-salnes-ink text-white"
      data-testid="impacto-hero"
    >
      <div
        className="absolute inset-0 -z-10 opacity-40"
        style={{
          background:
            "radial-gradient(1200px circle at 20% 20%, rgba(16,185,129,0.35), transparent 60%), radial-gradient(1000px circle at 80% 90%, rgba(11,76,122,0.55), transparent 60%)",
        }}
      />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.06),transparent_40%)]" />
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10 py-28 lg:py-40 pt-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="flex items-center gap-4 mb-6"
        >
          <img src="/brand/eu-flag.svg" alt="EU" className="h-8 w-auto" />
          <div className="text-[11px] uppercase tracking-[0.28em] text-white/60">
            {t("fase7.hero_kicker")}
          </div>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-serif text-5xl lg:text-7xl leading-[1.05]"
          data-testid="impacto-hero-title"
        >
          {t("fase7.hero_title")}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 max-w-2xl text-lg lg:text-xl text-white/75"
        >
          {t("fase7.hero_sub")}
        </motion.p>
      </div>
    </section>
  );
}
